<div class="avatar-holder" *ngIf="avatarForm$ | async as avatarForm">
    <div class="form-holder">
        <div class="form-content">
            <serviceos-ng-local-loader
                [showLoader]="showLoader"
            ></serviceos-ng-local-loader>
            <form id="avatar-form">
                <div class="avatar-img">
                    <serviceos-web-avatar></serviceos-web-avatar>
                </div>
                <label for="change-photo">{{avatarForm.edit_button_title}}</label>
                <input
                    type="file"
                    id="change-photo"
                    accept="image/*"
                    (change)="onFileSelected($event)"
                />
            </form>
            <!-- <div class="membership-badge-holder">
                <span *ngIf="true" class="link" (click)="navigateTo('membership-club')">Not member yet?</span>
                <span *ngIf="false">i am member</span>
            </div> -->
        </div>
    </div>
</div>
